import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import Dialog from '../../Services/Common/Dialog';
import DatePicker from '../../Components/Datepicker_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import InputBasic from '../../Components/Input_Basic';
import GridModal from '../../Components/Modal_Grid';
import AgDatePicker from '../../Components/agGrid/ag-DatePicker';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { OtherHouses } from '@mui/icons-material';
import agDatePicker from '../../Components/agGrid/ag-DatePicker';
import BasicDatepicker from '../../Components/Datepicker_Basic';
import Commons from '../../Services/Common/Common';

function SM10010(props) {
    React.useEffect(() => {
        document.title = '주문정보입력';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '영업관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>주문정보입력</strong>" +
            '</h1>';
    }, []);
    const [modalToggle, setModalToggle] = React.useState(false);
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [modalToggle1, setModalToggle1] = React.useState(false);
    const [selectedRowData1, setSelectedRowData1] = React.useState(null);
    const [selectedModalData1, setSelectedModalData1] = React.useState(null);
    const [rowIndex, setRowIndex] = React.useState(-1);

    const [checkInputs, setCheckInputs] = React.useState({
        value: '',
        value1: '',
        itemType: '',
    });
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    const [saveSoNo, setSaveSoNo] = React.useState('');
    const columnDefs = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        //주문일자
        {
            field: 'soDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDate' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        },
        //사업장
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
            cellRenderer: Commons.CustomPlantRenderer,
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 140,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 140,
        },
        //마감유무
        {
            field: 'closeYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CloseYn' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            cellStyle: { textAlign: 'center' },
            minWidth: 110,
        },
        //주문번호
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoNo' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        },
    ];
    const columnDefs1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            cellRenderer: (e) => {
                return !e.data ? 'TOTAL' : e.data.no;
            },
        },
        //공정
        {
            field: 'plnatCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '',
            hide: true,
            minWidth: 110,
        },
        //상태명
        {
            field: 'stusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StatusName' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'center' },
            minWidth: 100,
            minWidth: 110,
            cellRenderer: Commons.CustomHeaderRenderer,
        },

        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            cellRenderer: (e) => {
                return !e.data ? (
                    <a></a>
                ) : e.data.itemCd ? (
                    <span style={{ color: 'black' }}>{e.data.itemNm}</span>
                ) : (
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Setting' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        onClick={() => AuthGroupSettingClicked1(e)}
                    />
                );
            },
            minWidth: 280,
        },
        //주문수량
        {
            field: 'itemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: (e) => (e.data.stusNm === '주문완료' || e.data.stusNm == undefined ? true : false),

            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
            minWidth: 100,
        },
        //품목단가
        {
            field: 'soItemCost',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemCost' && f.lanType === 'COL')[0].lanName
                    : '',
            suppressMovable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 100,
        },
        //금액
        {
            field: 'soItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
            minWidth: 100,
        },
        //부가세
        {
            field: 'soItemVat',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemVat' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed()
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
            minWidth: 100,
        },
        //납기번호
        {
            field: 'soDueNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            editable: (e) => (e.data.stusNm === '주문완료' || e.data.stusNm == undefined ? true : false),
        },
        //납기일
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            suppressMovable: true,
            editable: (e) => (e.data.stusNm === '주문완료' || e.data.stusNm == undefined ? true : false),
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',

            minWidth: 110,
        }, //고객사품목코드
        {
            field: 'custItemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustItemCd' && f.lanType === 'COL')[0].lanName
                    : '',

            minWidth: 190,
        },
    ];
    const AuthGroupGridColumnDef = [
        //거래처코드
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    const AuthGroupGridColumnDef1 = [
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //고객사품목코드
        {
            field: 'custItemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: true,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //품목단가
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemCost' && f.lanType === 'COL')[0].lanName
                    : '0',
            editable: true,
        },
    ];
    const AuthGroupSettingClicked = (_data) => {
        if (_data) {
            setSelectedRowData({ ..._data.data });
        }
        // props.GetSalesOrderItemdtls(saveSoNo);
        setModalToggle(true);
        props.setAuthGroupGridRowData([]);
        setCheckInputs({
            ...checkInputs,
            value: '',
        });
    };
    const AuthGroupSettingClicked1 = (_data) => {
        // setSelectedRowData1({ ..._data.data });
        // props.GetSalesOrderItemdtls(saveSoNo);
        setModalToggle1(true);
        props.setAuthGroupGridRowData1([]);
        setCheckInputs({
            ...checkInputs,
            value1: '',
        });
    };
    // Row를 선택할때마다 동작하는 Callback함수
    const onSelectionChanged = React.useCallback(() => {
        const selected = gridRef.current.api.getSelectedRows();
        const selected1 = gridRef1.current.api.getSelectedRows();
        props.setSelectedRowData(selected);
        props.setSelectedRowData(selected1);
    }, []);

    const onCellClicked = (e) => {
        const selected = e.data;
        setSaveSoNo(selected.soNo);
        props.GetSalesOrderItemdtls(selected.soNo);
        props.setInputs({
            ...props.inputs,
            statusNm: selected.statusNm,
            itemType: selected.itemType,
            soNo: selected.soNo,
            soDt: new Date(selected.soDt),
            custCd: selected.custCd,
            custNm: selected.custNm,
            closeYn: selected.closeYn,
            remark: selected.remark,
            plantCd: selected.plantCd,
            currencyNm: selected.currencyNm,
            plantNm: selected.plantNm,
            updateId: selected.updateId,
        });
    };

    React.useEffect(() => {
        if (props.checkUserIdToggle === true) {
            props.setInputs({
                ...props.inputs,
                plantCd: '',
                soNo: props.checkInputs.value2,
                custNm: props.checkInputs.value3,
            });
        }
        props.setCheckInputs({
            ...props.checkInputs,
            value1: '',
            value2: '',
            value3: '',
        });

        props.setCheckUserIdToggle(false);
    }, [props.checkUserIdToggle]);

    React.useEffect(() => {
        if (props.checkSoNoToggle === true) {
            gridRef1.current.api.setRowData([
                {
                    plantCd: props.checkInputs1.value1,
                    soNo: props.checkInputs1.value2,
                },
                ...props.rowData1,
            ]);
        }
        props.setCheckInputs1({
            ...props.checkInputs1,
            value1: '',
            value2: '',
        });

        props.setCheckSoNoToggle(false);
    }, [props.checkSoNoToggle]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '72%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px' }}
                            selected={props.startDate}
                            onChange={(e) => {
                                props.setStartDate(e);
                            }}
                        />
                        ~
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginLeft: '5px' }}
                            selected={props.endDate}
                            onChange={(e) => {
                                props.setEndDate(e);
                            }}
                        />
                    </div>
                    <AuthGroupButton
                        pageName="SM10010"
                        target="G01"
                        refreshNone="none"
                        selectFunc={() => {
                            props.SearchLogic();
                        }}
                        addFunc={() => {
                            // () => gridRef.current.api.setRowData([{}, ...props.rowData])
                        }}
                        saveFunc={() => props.SaveConfirm('save')}
                        deleteFunc={() => props.DeleteConfirm('Delete')}
                    />
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            // minWidth: 150,
                            editable: true,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        rowData={props.rowData}
                        rowSelection="multiple"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        onCellClicked={onCellClicked}
                        // suppressRowClickSelection={true}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        groupDefaultExpanded={1}
                        suppressAggFuncInHeader={true}
                        enableCellChangeFlash={true}
                        getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                    />
                </div>
            </div>
            <div>
                <div>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <CardH3
                            wrapStyle={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                            //주문정보입력
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Fom_OrderInfomation' && f.lanType === 'FORM'
                                      )[0].lanName
                                    : ''
                            }
                        ></CardH3>
                        <AuthGroupButton
                            pageName="SM10010"
                            target="F01"
                            // refreshNone="none"
                            refreshFunc={() => {
                                props.Reset();
                                props.setRowData1([]);
                                props.setSelectedRowData([]);
                            }}
                            addFunc={(e) => {
                                props.Reset();
                                AuthGroupSettingClicked();
                                props.setRowData1([]);
                            }}
                            saveFunc={() => props.SaveConfirm('save')}
                            deleteFunc={() => props.DeleteConfirm()}
                        />
                    </Card>
                    <Section />
                    <Card style={{ height: '140px', marginTop: '0px' }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                                alignItems: 'center',
                            }}
                        >
                            <FormGroup
                                // columnCount={1}
                                datas={[
                                    //거래처코드
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_CustCd' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '',
                                        inputClass: 'input',
                                        value: props.inputs.custCd ? props.inputs.custCd : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                custCd: e.target.value,
                                            });
                                        },
                                        clicked: true,
                                        onClick: (e) => {
                                            if (props.inputs.soNo == '') {
                                                AuthGroupSettingClicked(e);
                                                props.setRowData1([]);
                                            }
                                        },
                                        readOnly: true,
                                    },
                                    //거래처명
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_CustNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '',
                                        inputClass: 'input',
                                        value: props.inputs.custNm ? props.inputs.custNm : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                custNm: e.target.value,
                                            });
                                        },
                                        readOnly: true,
                                    },
                                    //주문일자
                                    {
                                        type: 'date',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_SoDt' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '',
                                        value: props.inputs.soDt,
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                soDt: e,
                                            });
                                        },
                                    },
                                    //주문번호
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_SoNo' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '',
                                        inputClass: 'input',
                                        value: props.inputs.soNo ? props.inputs.soNo : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                soNo: e.target.value,
                                            });
                                        },
                                        readOnly: true,
                                    }, //사업장
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_PlantCd' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '',
                                        inputClass: 'input',
                                        value: props.inputs.plantNm ? props.inputs.plantNm : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                plantNm: e.target.value,
                                            });
                                        },
                                        readOnly: true,
                                    }, //작성담당자
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_userNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '',
                                        inputClass: 'input',
                                        value: props.inputs.updateId ? props.inputs.updateId : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                updateId: e.target.value,
                                            });
                                        },
                                        readOnly: true,
                                    },
                                ]}
                            />
                            <textarea
                                style={{
                                    height: '120px',
                                    width: '400px',
                                    margin: '0px 5px',
                                    padding: '5px',
                                    fontSize: '16px',
                                    border: '1px solid #e4e4e4',
                                }}
                                value={props.inputs.remark}
                                onChange={(e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        remark: e.target.value,
                                    });
                                }}
                                //비고
                                placeholder={
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Fom_Remark' && f.lanType === 'FORM'
                                          )[0].lanName
                                        : ''
                                }
                            />
                        </div>
                    </Card>
                </div>

                <div>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <AuthGroupButton
                            pageName="SM10010"
                            target="G02"
                            refreshFunc={() => props.GetSalesOrderItemdtls(props.selectedRowData[0].SoNo)}
                            refreshNone="none"
                            addFunc={() => {
                                if (props.rowData1.length === 0) {
                                    gridRef1.current.api.setRowData([{ soDueDt: new Date() }, ...props.rowData1]);
                                } else if (props.rowData1[0].itemQty) {
                                    gridRef1.current.api.setRowData([{ soDueDt: new Date() }, ...props.rowData1]);
                                } else {
                                    props.setAddEventController('1');
                                    gridRef1.current.api.setRowData([{ soDueDt: new Date() }, ...props.rowData1]);
                                }

                                props.setModalToggle1(true);
                            }}
                            saveFunc={() => props.SaveConfirm()}
                            deleteFunc={() => props.DeleteConfirm()}
                        />
                    </Card>
                    <Section />
                    <Card style={{ height: '160px', marginTop: '0px' }}>
                        <FormGroup
                            className="formGroup_info_box"
                            // columnCount={4}
                            datas={[
                                //총금액
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_TotalAmt' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    value: props.totalInputs.totalAmt,
                                    inputType: 'number',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setTotalInputs({
                                            ...props.totalInputs,
                                            totalAmt: value,
                                        });
                                    },
                                    readOnly: true,
                                },
                                //거래통화
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CurrencyNm' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    value: props.inputs.currencyNm ? props.inputs.currencyNm : '',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setInputs({
                                            ...props.inputs,
                                            currencyNm: value,
                                        });
                                    },
                                    readOnly: true,
                                },
                                //환율
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CurrencyAmt' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    value: props.inputs.currencyNm === '원화' ? 1 : props.totalInputs.currencyAmt,
                                    inputType: 'number',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setTotalInputs({
                                            ...props.totalInputs,
                                            currencyAmt: value,
                                        });
                                    },
                                },
                                //총금액(원화)
                                {
                                    type: 'input',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_TotalAmt(won)' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '',
                                    value:
                                        props.inputs.currencyNm === '원화'
                                            ? props.totalInputs.totalAmt * 1
                                            : props.totalInputs.totalAmt * props.totalInputs.currencyAmt,
                                    inputType: 'number',
                                    onChange: (e) => {
                                        let { value } = { ...e.target };
                                        props.setTotalInputs({
                                            ...props.totalInputs,
                                            kTotalAmt: value,
                                        });
                                    },
                                    readOnly: true,
                                },
                            ]}
                        />
                    </Card>
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '390px' }}>
                        <AgGridReact
                            ref={gridRef1}
                            animateRows={true}
                            columnDefs={columnDefs1}
                            groupIncludeTotalFooter={true}
                            defaultColDef={{
                                flex: 1,
                                // minWidth: 150,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            frameworkComponents={{
                                customHeaderRenderer: Commons.CustomHeaderRenderer,
                            }}
                            onCellValueChanged={(e) => {
                                let a = props.rowData1;
                                let b = props.changedRowData1;
                                let rowIndex = e.rowIndex;
                                if (e.oldValue !== e.newValue) {
                                    props.rowData1.map((item, index) => {
                                        if (item.itemCd === e.data.itemCd && rowIndex === index) {
                                            item.soItemAmt =
                                                e.data.itemVatYn === 'Y'
                                                    ? item.soItemCost * e.data.itemQty +
                                                      item.soItemCost * e.data.itemQty * 0.1
                                                    : item.soItemCost * e.data.itemQty;
                                            item.soItemVat =
                                                e.data.itemVatYn === 'Y' ? item.soItemCost * e.data.itemQty * 0.1 : 0;
                                            item.soDueDt = !e.data.soDueDt ? new Date() : e.data.soDueDt;
                                        }
                                    });
                                }
                                props.setChangedRowData1((current) => [...current]);
                            }}
                            rowData={props.rowData1}
                            rowSelection="multiple"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)
                            }
                            getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                        />
                    </div>
                </div>
            </div>
            {modalToggle && (
                <GridModal
                    conditions={[
                        {
                            type: 'input',
                            //거래처코드/명
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Fom_CustCd/Nm' && f.lanType === 'FORM'
                                      )[0].lanName
                                    : '',
                            value: checkInputs.value,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    value: e.target.value,
                                });
                            },
                            onClick: () => {},
                            onKeyDown: (e) => {
                                props.GetCommonCustList(checkInputs.value);
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '',
                            onClick: (e) => {
                                props.GetCommonCustList(checkInputs.value);
                            },
                        },
                    ]}
                    //거래처정보
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Fom_CustInfomation' && f.lanType === 'FORM')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setModalToggle(false)}
                    gridColumn={AuthGroupGridColumnDef}
                    gridRowData={props.authGroupGridRowData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridRowSelection={'multiple'}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                plantCd: e[i].plantCd,
                                plantNm: e[i].plantNm,
                                updateId: e[i].updateId,
                                custCd: e[i].custCd,
                                custNm: e[i].custNm,
                            });
                        }
                        setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        if (selectedModalData) {
                            props.setInputs({
                                ...props.inputs,
                                plantCd: selectedModalData[0].plantCd,
                                plantNm: selectedModalData[0].plantNm,
                                updateId: selectedModalData[0].updateId,
                                custCd: selectedModalData[0].custCd,
                                custNm: selectedModalData[0].custNm,
                            });
                        }
                    }}
                />
            )}
            {modalToggle1 && (
                <GridModal
                    conditions={[
                        {
                            type: 'combo',
                            //품목타입
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Fom_ItemTypeNm' && f.lanType === 'FORM'
                                      )[0].lanName
                                    : '',
                            combos: props.inputs.comboList.filter(
                                (x) =>
                                    x.value == 'ITEM_TYPE_01' || x.value == 'ITEM_TYPE_04' || x.value == 'ITEM_TYPE_05'
                            ),
                            value: props.checkInputs.itemType,
                            onChange: (e) => {
                                props.setCheckInputs({
                                    ...checkInputs,
                                    itemType: e,
                                });
                            },
                        },
                        {
                            type: 'input',
                            //품목코드/명
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Fom_ItemCd/Nm' && f.lanType === 'FORM'
                                      )[0].lanName
                                    : '',
                            value: checkInputs.value1,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    value1: e.target.value,
                                });
                            },
                            onClick: () => {},
                            onKeyDown: (e) => {
                                props.GetCommonItemList(checkInputs.value1);
                            },
                        },

                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '',
                            onClick: (e) => {
                                props.GetCommonItemList(checkInputs.value1);
                            },
                        },
                    ]}
                    //품목코드설정
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Fom_ItemCdSetting' && f.lanType === 'FORM')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setModalToggle1(false)}
                    gridColumn={AuthGroupGridColumnDef1}
                    gridRowData={props.authGroupGridRowData1}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridRowSelection={'multiple'}
                    onCellValueChanged={(e) => {
                        // props.setChangedRowData1([]);
                        GridFunctions.onCellValueChanged(e, AuthGroupGridColumnDef1, props.setChangedRowData1);
                    }}
                    gridOnClick={(e) => {
                        let data = [];
                        data.push({
                            plantCd: e[0].plantCd,
                            itemCd: e[0].itemCd,
                            itemNm: e[0].itemNm,
                            itemStdAmt: e[0].itemStdAmt,
                            itemVatYn: e[0].itemVatYn,
                        });

                        setSelectedModalData1(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        let a = gridRef1.current.props.rowData;
                        if (selectedModalData1) {
                            let authIndex = -1;
                            for (let i = 0; i < props.authGroupGridRowData1.length; i++) {
                                if (props.authGroupGridRowData1[i].itemCd === selectedModalData1[0].itemCd) {
                                    authIndex = i;
                                }
                            }
                            if (props.authGroupGridRowData1.length > 0) {
                                props.setRowData1([
                                    {
                                        itemCd: props.authGroupGridRowData1[authIndex].itemCd,
                                        itemNm: props.authGroupGridRowData1[authIndex].itemNm,
                                        soItemCost: props.authGroupGridRowData1[authIndex].itemStdAmt,
                                        plantCd: props.authGroupGridRowData1[authIndex].plantCd,
                                        soDueDt: new Date(),
                                    },
                                    ...props.rowData1,
                                ]);
                            }
                        }
                    }}
                />
            )}
        </div>
    );
}

export default SM10010;
